(function () {
	'use strict';

	angular.module('ProjectModule').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('projects-root', {
			url: '/project',
			parent: 'logged',
			abstract: true,
			views: {
				content: {
					template: '<app-resize-wrapper><ui-view/></app-resize-wrapper>',
				},
			},
			resolve: {
				check: [
					'$q',
					'$window',
					'$log',
					'AppSelectorService',
					function ($q, $window, $log, AppSelectorService) {
						if (!AppSelectorService.getSelectedProjectId()) {
							$log.warn('No project selected');
						}
					},
				],
			},
		});

		$stateProvider.state('target-project', {
			url: '/:projectId',
			parent: 'projects-root',
			abstract: true,
			resolve: {
				selectedProject: [
					'$q',
					'$rootScope',
					'$stateParams',
					'$transition$',
					'ProjectService',
					'PermissionService',
					'AppSelectorService',
					function (
						$q,
						$rootScope,
						$stateParams,
						$transition$,
						ProjectService,
						PermissionService,
						AppSelectorService
					) {
						const deferred = $q.defer();
						if (
							AppSelectorService.getSelectedProjectId() !==
							$stateParams.projectId
						) {
							// Get project data and check project admin permissions
							const query =
								$transition$.to().name === 'projects-edit'
									? ProjectService.getProject($stateParams.projectId)
									: ProjectService.getProjectMetada($stateParams.projectId);

							query.then(function (response) {
								AppSelectorService.setSelectedProject(
									$stateParams.projectId,
									response.data.metadata.label,
									response.data.version,
									response.data.is_default_version,
									response.data.version_count
								).then(function () {
									// FIXME: projectId est obligatoire pour la recuperation des permissions inclus globaux
									PermissionService.getCurrentUserGlobalPermissions().then(
										function (globalPermResponse) {
											$rootScope.globalPermissions = globalPermResponse.data;
											deferred.resolve($stateParams.projectId);
										}
									);
								});
							});
						} else {
							deferred.resolve($stateParams.projectId);
						}
						return deferred.promise;
					},
				],
			},
		});

		$stateProvider.state('projects', {
			url: '/',
			parent: 'projects-root',
			data: {
				admin: true,
				access: 'project,member',
				title: 'Projects',
			},
			resolve: {
				defaultProject: [
					'$q',
					'$rootScope',
					'ProjectService',
					'AppSelectorService',
					'PermissionService',
					function ($q, $rootScope, ProjectService, AppSelectorService, PermissionService) {
						ProjectService.getDefaultProject()
							.then(function (response) {
								if (response.data) {
									AppSelectorService.setSelectedProject(
										response.data.id,
										response.data.metadata.label,
										response.data.version,
										response.data.is_default_version,
										response.data.version_count
									);
								}
							})
							.finally(function () {
								PermissionService.getCurrentUserGlobalPermissions().then(
									function (globalPermResponse) {
										$rootScope.globalPermissions = globalPermResponse.data;
									}
								);
								$q.resolve();
							});
					},
				],
			},
			views: {
				'@projects-root': {
					templateUrl: './src/components/modules/project/projects.html',
					controller: 'ProjectListController',
				},
			},
		});

		$stateProvider.state('projects-edit', {
			url: '/edit',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'project',
				title: 'Edition du Projet',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/project/projectForm.html',
					controller: 'ProjectController',
				},
			},
		});

		$stateProvider.state('gd-home', {
			url: '/generics-data/home',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'GD-Accueil',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/home/gd-home.html',
					controller: 'HomeController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('home', {
			url: '/home',
			parent: 'target-project',
			data: {
				admin: false,
				access: '*',
				title: 'HD-Accueil',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/home/hd-home.html',
					controller: 'HomeController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('projects-new', {
			url: '/new',
			parent: 'projects-root',
			data: {
				admin: true,
				access: 'project',
				title: 'Nouveau Projet',
			},
			views: {
				'@projects-root': {
					templateUrl: './src/components/modules/project/projectForm.html',
					controller: 'ProjectController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('project-list', {
			url: '/list',
			parent: 'projects-root',
			data: {
				admin: true,
				access: 'project,member',
				title: 'Projects',
			},
			resolve: {
				defaultProject: [
					'$q',
					'ProjectService',
					'AppSelectorService',
					function ($q, ProjectService, AppSelectorService) {
						ProjectService.getDefaultProject()
							.then(function (response) {
								if (response.data) {
									AppSelectorService.setSelectedProject(
										response.data.id,
										response.data.metadata.label,
										response.data.version,
										response.data.is_default_version,
										response.data.version_count
									);
								}
							})
							.finally(function () {
								$q.resolve();
							});
					},
				],
			},
			views: {
				'@projects-root': {
					template: `<app-project-list ng-prop-user_is_admin="$ctrl.userIsAdmin"></app-project-list>`,
					controller: [
						'connectedUserIsAdmin',
						function (connectedUserIsAdmin) {
							const $ctrl = this;
							$ctrl.userIsAdmin = connectedUserIsAdmin;
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('module-generics', {
			url: '/generics/home',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'GD-Accueil',
			},
			views: {
				'@target-project': {
					template: `<app-project-home ng-prop-module="'generics'" ng-prop-project_id="$ctrl.projectId"></app-project-home>`,
					controller: [
						'$stateParams',
						function ($stateParams) {
							const $ctrl = this;
							$ctrl.projectId = $stateParams.projectId;
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});
		$stateProvider.state('module-handle', {
			url: '/handle/home',
			parent: 'target-project',
			data: {
				admin: false,
				access: '*',
				title: 'HD-Accueil',
			},
			views: {
				'@target-project': {
					template: `<app-project-home ng-prop-module="'handle'" ng-prop-project_id="$ctrl.projectId">></app-project-home>`,
					controller: [
						'$stateParams',
						function ($stateParams) {
							const $ctrl = this;
							$ctrl.projectId = $stateParams.projectId;
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});
	}
})();
